import { Box, Button, Fade, Grid2, Tooltip } from "@mui/material";

const ActionButtonsPane = ({
    actions = [],
    selectedItem
}) => {
    return (
        <Grid2>
            <Box display="flex" flexDirection="column" gap={2} width="140px">
                {actions.map((action = {}, idx) => {
                    const color = action.color || 'grey';
                    return (
                        <Tooltip
                          key={action.label}
                          title={ <h1 style={{ color: "lightblue", fontSize: "20px" }}>{!action.active() ? action.hintNotActive : action.hintActive || null} </h1> }
                          placement="bottom"
                          arrow
                          slots={{
                            transition: Fade,
                          }}
                          enterDelay={750}
                          leaveDelay={100}
                        >
                        <div>
                        <Button
                            variant="contained"
                            disabled={!action.active()}
                            onClick={() => {
                                action.handler();
                            }}
                            sx={{
                                backgroundColor: action.active() ? color : "grey.400",
                                color: "white",
                                width: "100%",
                                "&:hover": {
                                    backgroundColor: action.active() ? color : "grey.500",
                                },
                            }}
                        >
                            <b>{action.label}</b>
                        </Button>
                        </div>
                        </Tooltip>
                    );
                })}
            </Box>
        </Grid2>
    );
};
export default ActionButtonsPane;

